/**
 * useTrainingModes — reaktive Trainingsarten des aktiven Studios.
 *
 * Eine Quelle für alle Stellen, die Einlass-Funktionen ein- oder ausblenden:
 * Menü (Aside), Router-Guard, Views. Wer stattdessen selbst in
 * companies_infos greift, baut die vierte Variante derselben Suche — genau so
 * entstehen Abweichungen zwischen Menü und Route.
 */

import { computed } from 'vue'
import { useTablesStore } from '@/stores/tables'
import {
  TRAINING_MODES_TYPE,
  parseTrainingModes,
  defaultTrainingModes,
  hasAccessControl,
  type TrainingModes,
} from '@/core/helpers/trainingModes'

export function useTrainingModes () {
  const tablesStore = useTablesStore()

  const companyId = computed(() => (tablesStore as any).config?.ActiveCompany || '')

  const record = computed(() => {
    const infos: any[] = (tablesStore as any).tables?.companies_infos || []
    return infos.find((ci: any) =>
      ci.companyid === companyId.value && ci.type === TRAINING_MODES_TYPE && ci.archive === 0)
  })

  const modes = computed<TrainingModes>(() =>
    record.value ? parseTrainingModes(record.value.options) : defaultTrainingModes())

  /**
   * Ist der Einlass für dieses Studio überhaupt ein Thema?
   *
   * Solange companies_infos noch nicht synchronisiert ist, greifen die Defaults
   * (beides an) — der Einlass ist dann kurz sichtbar, statt kurz zu fehlen. Das
   * ist die richtige Richtung: ein Menüpunkt, der nachträglich verschwindet,
   * irritiert weniger als eine Ansicht, die beim Laden ins Dashboard wirft.
   */
  const showAccessControl = computed(() => hasAccessControl(modes.value))

  const offersCourseTraining = computed(() => modes.value.courseTraining)
  const offersFreeTraining = computed(() => modes.value.freeTraining)

  return {
    modes,
    showAccessControl,
    offersCourseTraining,
    offersFreeTraining,
    settingsRecord: record,
  }
}
